
export default {
    
    name: 'hfs',
    component: () => import(/* webpackChunkName: "Campus" */ '@/modules/sievi/layouts/SieviLayout.vue'),
    children: [
        {
            path:'',
            name:'hfs.empty',
            redirect: { name: 'sievi.error' },
        },
        {
            path: ':id/:contratoId',
            name: 'hfs.home',
            component: () => import(/* webpackChunkName: "Hfs-home" */ '@/modules/sievi/views/hfs.vue'),
            props: ( route ) => {
                return {
                    id: Number(route.params.id),
                    contratoId: Number(route.params.contratoId)
                }
            }
        },
        // {
        //     path: ':id',
        //     name: 'hfs.list',
        //     component: () => import(/* webpackChunkName: "Campus-list" */ '@/modules/sievi/views/auditor/hfs/List.vue'),
        //     props: ( route ) => {
        //         return {
        //             id: route.params.id
        //         }
        //     }
        // },
        {
            path: 'evidencias/',
            name: 'hfs.evidences.empty',
            redirect: { name: 'sievi.error' },
        },
        {
            path: 'evidencias/:id/:periodoId/:contratoId',
            name: 'hfs.evidences',
            component: () => import(/* webpackChunkName: "Hfs-evidences" */ '@/modules/sievi/views/Evidence.vue'),
            props: ( route ) => {
                return {
                    id: Number(route.params.id),
                    periodoId: Number(route.params.periodoId),
                    contratoId: Number(route.params.contratoId)
                }
            }
        },
        {
            path: 'evidencias/:id/:campusId/:hfsId/:programId/:teacherId/:contractId/:periodId',
            name: 'hfs.evidences.responsable',
            component: () => import(/* webpackChunkName: "Hfs-evidences" */ '@/modules/sievi/views/responsable/evidencias/List.vue'),
            props: ( route ) => {
                return {
                    id: Number(route.params.id),
                    campusId: Number(route.params.campusId),
                    hfsId: Number(route.params.hfsId),
                    programId: Number(route.params.programId),
                    teacherId: Number(route.params.teacherId),
                    contractId: Number(route.params.contractId),
                    periodId: Number(route.params.periodId),
                }
            }
        },
        {
            path: '/:pathMatch(.*)*',
            name: 'hfs.notfound',
            redirect: { name: 'sievi.error' },
        },
        {
            path: 'responsable/:id/:campusId',
            name: 'hfs.responsable',
            component: () => import(/* webpackChunkName: "Hfs-list" */ '@/modules/sievi/views/hfs.vue'),
            props: ( route ) => {
                return {
                    id: Number(route.params.id),
                    campusId: Number(route.params.campusId),
                }
            }
        },
        {
            path: 'auditor/:campusId/:programId/:teacherId/:contractId/:periodId',
            name: 'hfs.auditor',
            component: () => import(/* webpackChunkName: "Hfs-list" */ '@/modules/sievi/views/auditor/hfs/List.vue'),
            props: ( route ) => {
                return {
                    campusId: Number(route.params.campusId),
                    programId: Number(route.params.programId),
                    teacherId: Number(route.params.teacherId),
                    contractId: Number(route.params.contractId),
                    periodId: Number(route.params.periodId)
                }
            }
        },
        {
            path: 'auditor/evidencias/:campusId/:programId/:teacherId/:contractId/:periodId/:hfsId',
            name: 'hfs.evidences.auditor',
            component: () => import(/* webpackChunkName: "Hfs-evidences" */ '@/modules/sievi/views/auditor/evidencias/List.vue'),
            props: ( route ) => {
                return {
                    campusId: Number(route.params.campusId),
                    programId: Number(route.params.programId),
                    teacherId: Number(route.params.teacherId),
                    contractId: Number(route.params.contractId),
                    periodId: Number(route.params.periodId),
                    hfsId: Number(route.params.hfsId),
                }
            }
        },
    ],

}